import {FilterData, FilteringFlow} from "@filtering.js/filtering.js/ui";
import {animateInViewport} from "./transition";
import {toggleFilter, updateFilterContainerVisibility} from "./navigation";
import {resetLoadMore} from "./load-more";

$( function() {
	const $filtering = $( '.filtering' );

	if ( $filtering.length ) {
		const filteringElement = $filtering[ 0 ];

		// Prevent page reload when clicking on Portfolio in overlay menu
		$( '#menu-overlay-menu .menu-item.object-173' ).click( function( event ) {
			event.preventDefault();
			window.location.hash = '';
			const uri = window.location.toString();
			history.pushState( true, '', uri.substring( 0, uri.indexOf( "#" ) ) );
		} );

		class MyFilteringFlow extends FilteringFlow {
			handleFilterResult( result, filterData ) {
				if ( $( 'body' ).hasClass( 'page-template-page-guide' ) ) {

				} else {
					window.scrollTo( {
						top: 0,
						behavior: 'smooth',
					} );
				}

				super.handleFilterResult( result );

				$( '.filtering-item' ).removeClass( 'active' );
				$( '.no-results' ).toggleClass( 'hidden', result.filteredItems.length > 0 );
				resetLoadMore();

				$( '.blog .filter-items-container .filtering-filter.disabled' ).hide();
				$( '.filter-items-container' )
					.stop().slideUp( 'fast' )
					.attr( 'data-toggle-slide-direction', 'down' );
				window.msnry.masonry();

				this.updateFilterClasses( filterData );
				this.updateItemClasses( result );
				setTimeout( animateInViewport, 0 );

				storeFiltersToHash( filterData );
			}

			updateFilterClasses( filterData ) {
				$( '#menu-overlay-menu .menu-item' ).removeClass( 'current-menu-item' )
					.find( 'a' ).attr( 'aria-current', '' );

				if ( filterData.checkedFilters.size === 0 ) {
					toggleFilter( false );
					$( '.filter-toggle' ).parent().addClass( 'translate-x-full opacity-0 pointer-events-none' ).removeClass( 'pointer-events-auto' );
					$( `#menu-overlay-menu .menu-item.object-173` ).addClass( 'current-menu-item' ) // TODO: Hardcoded .string object-173
						.find( 'a' ).attr( 'aria-current', 'page' );
				} else {
					$( '.filter-toggle' ).parent().removeClass( 'translate-x-full opacity-0 pointer-events-none' ).addClass( 'pointer-events-auto' );
					for ( const [groupName, checkedFilters] of filterData.checkedFilters ) {
						for ( const checkedFilter of checkedFilters ) {
							const $filter = $( `.filtering-group[data-group-name="${groupName}"] .filtering-filter[data-filter-name="${checkedFilter}"]` );
							let parentTaxonomyId = $filter.attr( 'data-taxonomy-parent-id' );
							if ( parentTaxonomyId === '0' ) {
								parentTaxonomyId = $filter.attr( 'data-taxonomy-id' );
							}
							if ( parentTaxonomyId === undefined ) {
								continue;
							}
							$( `#menu-overlay-menu .menu-item.object-${parentTaxonomyId}` ).addClass( 'current-menu-item' )
								.find( 'a' ).attr( 'aria-current', 'page' );
							$( `.filtering-group[data-group-name="${groupName}"] .filtering-filter` ).each( function() {
								const $this = $( this );
								$this.toggleClass( 'hidden', $this.attr( 'data-taxonomy-parent-id' ) !== parentTaxonomyId );
							} );
							$( `.filtering-group[data-group-name="case-tag"] .filtering-filter` ).each( function() {
								const $this = $( this );
								const linkedCategories = $this.attr( 'data-linked-categories' ).split( ',' );
								$this.toggleClass( 'hidden', !linkedCategories.includes( parentTaxonomyId ) );
							} );
						}
					}
				}
			}

			updateItemClasses( result ) {
				const allClasses = ['lg:col-span-3', 'lg:col-span-2', 'lg:py-24', 'lg:pr-24', 'lg:pl-24', 'aspect-[672/620]', 'aspect-[443/570]'];
				const delayClasses = ['delay-[100ms]', 'delay-[200ms]', 'delay-[300ms]'];
				for ( const [index, item] of result.filteredItems.entries() ) {
					let itemClasses = [];
					switch ( index % 13 ) {
						case 0:
						case 1:
						case 8:
						case 9:
							itemClasses = ['lg:col-span-3', 'aspect-[343/570]', 'lg:aspect-[672/620]'];
							break;
						case 5:
							itemClasses = ['lg:col-span-2', 'lg:py-24', 'lg:pr-24', 'aspect-[672/620]'];
							break;
						case 7:
						case 11:
						case 12:
							itemClasses = ['lg:col-span-2', 'lg:py-24', 'lg:pl-24', 'aspect-[672/620]'];
							break;
						case 2:
						case 3:
						case 4:
						case 6:
						case 10:
						default:
							itemClasses = ['lg:col-span-2', 'aspect-[443/570]'];
					}

					const element = item.data.element;
					for ( const clazz of allClasses ) {
						element.classList.toggle( clazz, itemClasses.includes( clazz ) );
					}
					for ( const [i, clazz] of delayClasses.entries() ) {
						element.classList.toggle( clazz, i === index % 3 );
					}
				}
			}
		}

		const storeHash = filteringElement.dataset.storeHash === 'true';
		const filteringFlow = new MyFilteringFlow( document.body, {
			filteredItemClass: 'hidden',
			triggerFilterAfterInitializing: !storeHash,
		} );
		window.addEventListener( 'hashchange', loadFiltersFromHash );
		if ( storeHash ) {
			loadFiltersFromHash();
			updateFilterContainerVisibility();
		}
		$( '.filtering-filter' ).click( function( event ) {
			event.preventDefault();
			$( '.employee-search' ).val( '' );
			animateInViewport();
		} );
		$( '.enable-all-filters' ).click( function( event ) {
			event.preventDefault();
			for ( const group of filteringFlow.schema.groups ) {
				for ( const filter of group.filters ) {
					const filterElement = filter.data.element;

					if ( filterElement.dataset.filterType === 'all' ) {
						filterElement.classList.add( filteringFlow.parser.options.filterCheckedClass );
					} else {
						filterElement.classList.remove( filteringFlow.parser.options.filterCheckedClass );
					}
				}
			}
			filteringFlow.filter();
		} );
		window.filteringFlow = filteringFlow;

		function loadFiltersFromHash() {
			if ( !storeHash ) {
				return;
			}

			const hash = decodeURIComponent( window.location.hash.substring( 1 ) );
			const filteringData = new FilterData();
			if ( hash ) {
				const filteringAsQueryParams = new URLSearchParams( hash );
				for ( const [groupName, filterName] of filteringAsQueryParams ) {
					filteringData.checkFilter( groupName, filterName );
				}
			}
			filteringFlow.filter( filteringData );
		}

		function storeFiltersToHash( filterData ) {
			if ( !storeHash ) {
				return;
			}

			const filteringAsQueryParams = new URLSearchParams();
			for ( const [groupName, checkedFilters] of filterData.checkedFilters ) {
				for ( const checkedFilter of checkedFilters ) {
					filteringAsQueryParams.append( groupName, checkedFilter );
				}
			}
			const newHash = filteringAsQueryParams.toString();
			updateHash( newHash );
		}

		function updateHash( newHash ) {
			if ( newHash !== window.location.hash.substring( window.location.hash.indexOf( '#' ) + 1 ) ) {
				if ( newHash ) {
					window.location.hash = newHash;
				} else {
					const uri = window.location.toString();
					history.pushState( true, '', uri.substring( 0, uri.indexOf( "#" ) ) );
				}
			}
		}
	}
} );
